// The last route table answered by GET /api/app-routes is kept in localStorage (see appRoutes.js). This tiny reader needs no
// store, so the Redux slice and the axios interceptor (which cannot import the store) can find the login page from it.
export const ROUTES_KEY = "appRoutes:v1";
const ROOT = "/"; // the site root is the only path that is not looked up

export const savedLoginPath = (adminArea) => {
  try {
    const name = adminArea ? "admin-login" : "login";
    return (JSON.parse(window.localStorage.getItem(ROUTES_KEY) || "[]").find((r) => r.name === name) || {}).path || ROOT;
  } catch { return ROOT; }
};
